var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref } from "vue";
//@ts-ignore missing typedefs
import VirtualList from "vue-virtual-scroll-list";
import { isHistoryItem } from "@/api";
import { copyDataset } from "@/api/datasets";
import { useAnimationFrameResizeObserver } from "@/composables/sensors/animationFrameResizeObserver";
import { useAnimationFrameScroll } from "@/composables/sensors/animationFrameScroll";
import { Toast } from "@/composables/toast";
import { useEventStore } from "@/stores/eventStore";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import HistoryDropZone from "../CurrentHistory/HistoryDropZone.vue";
import MultipleViewItem from "./MultipleViewItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultipleViewList',
    props: {
        selectedHistories: null,
        filter: { default: "" }
    },
    emits: ["update:show-modal"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCheckSquare, faPlus);
        const historyStore = useHistoryStore();
        // defineEmits below
        const scrollContainer = ref(null);
        const { arrived } = useAnimationFrameScroll(scrollContainer);
        const isScrollable = ref(false);
        useAnimationFrameResizeObserver(scrollContainer, ({ clientSize, scrollSize }) => {
            isScrollable.value = scrollSize.width >= clientSize.width + 1;
        });
        const scrolledLeft = computed(() => !isScrollable.value || arrived.left);
        const scrolledRight = computed(() => !isScrollable.value || arrived.right);
        function createAndPin() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield historyStore.createNewHistory();
                    if (!historyStore.currentHistoryId) {
                        throw new Error("Error creating history");
                    }
                    if (historyStore.pinnedHistories.length > 0) {
                        historyStore.pinHistory(historyStore.currentHistoryId);
                    }
                }
                catch (error) {
                    console.error(error);
                    Toast.error(errorMessageAsString(error), "Error creating and pinning history");
                }
            });
        }
        const showDropZone = ref(false);
        const processingDrop = ref(false);
        function onDrop(evt) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const eventStore = useEventStore();
                if (processingDrop.value) {
                    showDropZone.value = false;
                    return;
                }
                processingDrop.value = true;
                showDropZone.value = false;
                const dragItems = eventStore.getDragItems();
                // Filter out any non-history items
                const historyItems = dragItems === null || dragItems === void 0 ? void 0 : dragItems.filter((item) => isHistoryItem(item));
                const multiple = historyItems.length > 1;
                const originalHistoryId = (_a = historyItems === null || historyItems === void 0 ? void 0 : historyItems[0]) === null || _a === void 0 ? void 0 : _a.history_id;
                if (historyItems && originalHistoryId) {
                    yield historyStore.createNewHistory();
                    const currentHistoryId = historyStore.currentHistoryId;
                    let datasetCount = 0;
                    let collectionCount = 0;
                    if (currentHistoryId) {
                        // iterate over the data array and copy each item to the new history
                        for (const item of historyItems) {
                            const dataSource = item.history_content_type === "dataset" ? "hda" : "hdca";
                            yield copyDataset(item.id, currentHistoryId, item.history_content_type, dataSource)
                                .then(() => {
                                if (item.history_content_type === "dataset") {
                                    datasetCount++;
                                    if (!multiple) {
                                        Toast.info(localize("Dataset copied to new history"));
                                    }
                                }
                                else {
                                    collectionCount++;
                                    if (!multiple) {
                                        Toast.info(localize("Collection copied to new history"));
                                    }
                                }
                            })
                                .catch((error) => {
                                Toast.error(errorMessageAsString(error));
                            });
                        }
                        if (multiple && datasetCount > 0) {
                            Toast.info(`${datasetCount} dataset${datasetCount > 1 ? "s" : ""} copied to new history`);
                        }
                        if (multiple && collectionCount > 0) {
                            Toast.info(`${collectionCount} collection${collectionCount > 1 ? "s" : ""} copied to new history`);
                        }
                        if (historyStore.pinnedHistories.length > 0) {
                            // pin the newly created history via the drop
                            historyStore.pinHistory(currentHistoryId);
                            // also pin the original history where the item came from
                            historyStore.pinHistory(originalHistoryId);
                        }
                    }
                    processingDrop.value = false;
                }
            });
        }
        function onKeyDown(evt) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function* () {
                if (evt.key === "Enter" || evt.key === " ") {
                    if ((_b = (_a = evt.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains("top-picker")) {
                        yield createAndPin();
                    }
                    else if ((_d = (_c = evt.target) === null || _c === void 0 ? void 0 : _c.classList) === null || _d === void 0 ? void 0 : _d.contains("bottom-picker")) {
                        emit("update:show-modal", true);
                    }
                }
            });
        }
        return { __sfc: true, historyStore, props, emit, scrollContainer, arrived, isScrollable, scrolledLeft, scrolledRight, createAndPin, showDropZone, processingDrop, onDrop, onKeyDown, faCheckSquare, faPlus, FontAwesomeIcon, VirtualList, localize, HistoryDropZone, MultipleViewItem };
    }
});
